import * as React from "react"
import NewsLetterSignUp from "@components/NewsletterSignUp"

const StrapiNewsletterSignup = ({
    title,
    subtitle
}: GatsbyTypes.NewsletterSignupFragment) => {
    return <NewsLetterSignUp
        title={`${title}`}
        subtitle={`${subtitle}`}
    />
}

export default StrapiNewsletterSignup
